module.exports = __webpack_public_path__ + "static/media/993771.49b6018d.png";